"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
/**
 * @react-component SelectComponent - floating label select box
 */
function SelectComponent(props) {
    var errorClass = props.hasError ? ' vx_has-error' : '';
    return (React.createElement("div", { className: "vx_floatingLabel " + errorClass },
        React.createElement("label", { className: "floatingLabel", htmlFor: props.id }, props.label),
        React.createElement("div", { className: "vx_select", "data-label-content": props.label },
            React.createElement("select", { id: props.id, className: "form-control vx_form-control test_" + props.name, name: props.name, value: props.value, onChange: props.onChange }, props.children)),
        React.createElement("span", { className: "vx_selectIcon_error" })));
}
exports.default = SelectComponent;
